import { cn } from "@repo/utils";
import type { DialogFooterProps } from "../dialog.types.js";

export const DialogFooter = ({ className, sticky = false, children }: DialogFooterProps) => {
  return (
    <div
      className={cn("flex flex-col-reverse gap-3 pt-4 sm:flex-row sm:justify-end", className, {
        "sticky bottom-0 border-t border-gray-200 bg-white": sticky,
      })}
    >
      {children}
    </div>
  );
};
